import React from "react";
import { Button } from "react-bootstrap";
import { LoadingSpinner } from "../common/Loading/LoadingSpinner";

/** Right-aligned Save/Cancel group (full-width row). */
export function EditFormActions({
  children,
  className = "",
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const classes = `d-flex flex-wrap gap-2 justify-content-end w-100 mt-4 ${className}`.trim();
  return <div className={classes}>{children}</div>;
}

/** Footer with optional left admin actions and right-aligned Save/Cancel. */
export function EditFormSplitFooter({
  start,
  children,
  className = "my-4",
}: {
  start?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}) {
  const rowClass = `d-flex flex-wrap gap-2 justify-content-between align-items-center w-100 ${className}`.trim();
  return (
    <div className={rowClass}>
      {start ?? null}
      <div className="d-flex flex-wrap gap-2 justify-content-end ms-auto">{children}</div>
    </div>
  );
}

export interface EditFormSaveCancelButtonsProps {
  isSubmitting: boolean;
  onCancel: () => void;
  saveLabel?: string;
  disabled?: boolean;
}

export function EditFormSaveCancelButtons({
  isSubmitting,
  onCancel,
  saveLabel = "Save",
  disabled = false,
}: EditFormSaveCancelButtonsProps) {
  return (
    <>
      <Button variant="primary" type="submit" disabled={disabled || isSubmitting}>
        {isSubmitting ? <LoadingSpinner text="Saving…" /> : saveLabel}
      </Button>
      <Button variant="outline-secondary" type="button" onClick={onCancel}>
        Cancel
      </Button>
    </>
  );
}
